import { render } from "./RekapDataIg.vue?vue&type=template&id=91c1a56a"
import script from "./RekapDataIg.vue?vue&type=script&lang=js"
export * from "./RekapDataIg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__